import { colorHslToHex } from '@/shared/lib/colors'

import { OWN_COLOR } from './own'

export const STATIC_COLOR_FALLBACK = {
  white: colorHslToHex({
    h: OWN_COLOR.white.h,
    s: OWN_COLOR.white.s,
    l: OWN_COLOR.white.l.default,
  }),
  neutral: {
    default: colorHslToHex({
      h: OWN_COLOR.neutral.h,
      s: OWN_COLOR.neutral.s,
      l: OWN_COLOR.neutral.l.default,
    }),
  },
}
